var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 10.8335H9.66683V12.1668H0.333496V10.8335Z",
    fill: "#89A6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60683 5.22683L1.66683 6.16683L5.00016 9.50016L8.3335 6.16683L7.3935 5.22683L5.66683 6.94683V0.833496H4.3335V6.94683L2.60683 5.22683Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlueIcon);
export default __webpack_public_path__ + "static/media/download_blue_icon.6592e8bbd11332eb14e963292d8a903b.svg";
export { ForwardRef as ReactComponent };